import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { Orientation, Tooltip } from '@dojo/widgets/tooltip';
import { Icon } from '@holmescorp/base-widgets';
import { convertToBoolean } from '@holmescorp/common';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';
import css from '../css/card.m.css';
const icache = createICacheMiddleware();
const factory = create({ icache, theme, nls: createNlsMiddleware('ditabook') })
    .properties()
    .children();
export const Card = factory(({ id, children, properties, middleware: { icache, theme, nls } }) => {
    const widgetId = `card-${id}`;
    const themeCss = theme.classes(css);
    const { xqa, aria = {}, mediaSrc, mediaTitle, disabled = false, nlsKey = '', ispromotedisabled = 'true', ispromotable = 'false', ispromoted = 'false' } = properties();
    const { header, content } = children()[0] || {};
    const { messages: { card_promote_tooltip = '', card_demote_tooltip = '' } } = nls();
    const props = {
        ispromotedisabled: convertToBoolean(ispromotedisabled),
        ispromotable: convertToBoolean(ispromotable),
        ispromoted: convertToBoolean(ispromoted)
    };
    const promote_actions = v('div', {
        classes: [themeCss.promote, !props.ispromotable ? themeCss.disabledPromote : null, 'cardActions'],
        onclick: () => {
            if (props.ispromotable) {
                publish('tool:studyplan:modify', {
                    key: nlsKey,
                    type: 'resource',
                    state: props.ispromoted ? 'promoted' : 'demoted',
                    action: props.ispromoted ? 'remove' : 'add'
                });
            }
            icache.set('promote_ttopen', false);
            icache.set('demote_ttopen', false);
        }
    }, [
        props.ispromoted
            ? w(Tooltip, {
                open: icache.getOrSet('demote_ttopen', false),
                orientation: Orientation.top
            }, [
                {
                    content: card_demote_tooltip,
                    trigger: v('span', {
                        onmouseover: () => props.ispromotable && icache.set('demote_ttopen', true),
                        onmouseout: () => props.ispromotable && icache.set('demote_ttopen', false),
                        onfocus: () => props.ispromotable && icache.set('demote_ttopen', true),
                        onblur: () => props.ispromotable && icache.set('demote_ttopen', false)
                    }, [
                        w(Icon, {
                            fapre: 'far',
                            faname: 'square-minus'
                        })
                    ])
                }
            ])
            : w(Tooltip, {
                open: icache.getOrSet('promote_ttopen', false),
                orientation: Orientation.top
            }, [
                {
                    content: card_promote_tooltip,
                    trigger: v('span', {
                        onmouseover: () => props.ispromotable && icache.set('promote_ttopen', true),
                        onmouseout: () => props.ispromotable && icache.set('promote_ttopen', false),
                        onfocus: () => props.ispromotable && icache.set('promote_ttopen', true),
                        onblur: () => props.ispromotable && icache.set('promote_ttopen', false)
                    }, [
                        w(Icon, {
                            fapre: 'far',
                            faname: 'square-plus'
                        })
                    ])
                }
            ])
    ]);
    return v('div', {
        id,
        widgetId,
        xqa,
        ...formatAriaProperties(aria),
        classes: [themeCss.root, theme.variant(), disabled ? themeCss.disabled : null],
        tabIndex: 0
    }, [
        v('div', {
            key: 'content',
            classes: [themeCss.content]
        }, [
            header ? v('h2', { key: 'header', classes: [themeCss.header] }, [header]) : null,
            mediaSrc
                ? v('img', {
                    key: 'media',
                    title: mediaTitle,
                    alt: mediaTitle,
                    classes: [themeCss.media],
                    src: `${mediaSrc}`
                })
                : null,
            content
                ? v('div', {}, [
                    props.ispromoted === undefined || props.ispromotedisabled ? null : promote_actions,
                    content
                ])
                : null
        ])
    ]);
});
export default Card;
